__turbopack_context__.v({
  "content": "PageBlock-module-scss-module__spRQGG__content",
});
